import { render, staticRenderFns } from "./BaseSpanIcon.vue?vue&type=template&id=5eb475dc&scoped=true&"
import script from "./BaseSpanIcon.vue?vue&type=script&lang=js&"
export * from "./BaseSpanIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpanIcon.vue?vue&type=style&index=0&id=5eb475dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb475dc",
  null
  
)

export default component.exports